export const getAnnouncementState = (state: Partial<GlobalState>) => state.announcement;
